import { SyntheticEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, useNavigate, useOutletContext } from 'react-router'

import { PublicRoutes, SetupWorkspaceRoutes } from 'app/application/types'
import { ArrowRightIcon } from 'app/common/presentation/icons'

import { Button, Input } from 'components'

import accessStyles from '../AccessPage/AccessPage.module.scss'
import { UserAccessContext, isCreateWorkspaceInput } from './CreateAccess'
import styles from './CreateAccess.module.scss'

const SignUp = () => {
  const { t } = useTranslation('user')
  const navigate = useNavigate()
  const { error, formInput, loggedIn, setFormInput } = useOutletContext<UserAccessContext>()

  const isCreateWorkspace = isCreateWorkspaceInput(formInput)
  const inviteSearch = new URLSearchParams({
    email: formInput.email,
    inviteCode: formInput.inviteCode,
  }).toString()

  if (isCreateWorkspace && (!formInput.workspace.trim() || loggedIn)) {
    return <Navigate to={`${PublicRoutes.CreateWorkspace}?${inviteSearch}`} replace />
  }

  const handleSubmit = (e: SyntheticEvent) => {
    e.preventDefault()

    void navigate({
      pathname: `${isCreateWorkspace ? PublicRoutes.CreateWorkspace : PublicRoutes.SignUp}/${SetupWorkspaceRoutes.Password}`,
      search: inviteSearch,
    })
  }

  return (
    <>
      <div className={styles.intro}>
        <h1>{t('create.welcome_signup')}</h1>
        <div className={accessStyles.message}>{t('create.message_signup')}</div>
        <div className={styles.progress} aria-hidden="true">
          <span className={styles.currentStep} />
          <span />
          <span />
        </div>
      </div>
      <form onSubmit={handleSubmit}>
        <div className={accessStyles.inputs}>
          <div className={styles.name}>
            <Input
              autoComplete="given-name"
              autoFocus
              label={t('create.firstName')}
              mandatory
              onChange={
                error || loggedIn
                  ? undefined
                  : (firstName) =>
                      setFormInput((prev) => ({
                        ...prev,
                        firstName,
                      }))
              }
              placeholder={t('create.placeholder.firstName')}
              value={formInput.firstName}
            />
            <Input
              autoComplete="family-name"
              label={t('create.lastname')}
              mandatory
              onChange={
                error || loggedIn
                  ? undefined
                  : (lastName) =>
                      setFormInput((prev) => ({
                        ...prev,
                        lastName,
                      }))
              }
              placeholder={t('create.placeholder.lastname')}
              value={formInput.lastName}
            />
          </div>
          <Input
            autoComplete="username"
            error={error}
            label={t('create.email')}
            mandatory
            placeholder={t('create.placeholder.email')}
            value={formInput.email}
          />
        </div>
        <div className={styles.signUpActions}>
          <Button
            disabled={!!error || !formInput.firstName.trim() || !formInput.lastName.trim()}
            rightIcon={loggedIn ? undefined : <ArrowRightIcon />}
            type="submit"
          >
            {t('create.next')}
          </Button>
        </div>
      </form>
    </>
  )
}

export default SignUp
